<template>
  <div class="form-group">
    <label :for="`language-select-${_uid}`">Sprache</label>
    <select class="form-control" :id="`language-select-${_uid}`" @change="onLanguageChange" v-model="selectedLanguage">
      <option v-for="language in availableLanguages" :key="`language-${language.iso}-${_uid}`" v-bind:value="language.iso">
        {{ language.title }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'LanguageSelector',

  props: {
    language: {
      type: String,
      default: 'de',
    },
  },

  data() {
    return {
      availableLanguages: [
        {
          title: 'Deutsch',
          iso: 'de',
        },
        {
          title: 'Englisch',
          iso: 'en',
        },
      ],

      selectedLanguage: 'de',
    };
  },

  watch: {
    language(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedLanguage = newVal;
      }
    },
  },

  methods: {
    onLanguageChange() {
      this.$emit('language-selector:change', this.selectedLanguage);
    },
  },
};
</script>
